module.exports = __webpack_public_path__ + "img/banner02_id.4017b091.jpg";